import { Box, Typography } from "@mui/material";
import { Flex } from "Components/_Shared/Core/Flex";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { ReactNode } from "react";

type GoalCardDetail = { label: string; value: string };

type Props = {
  title: string;
  details?: GoalCardDetail[];
  children: ReactNode;
};

/** Frames goal-bound content the same way in the questionnaire steps and on the evaluation page. */
export const QuestionnaireGoalCard = ({ title, details = [], children }: Props) => (
  <Box border="1px solid" borderColor="divider" borderRadius={Radius.L} overflow="hidden" sx={{ breakInside: "avoid" }}>
    <Flex
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      columnGap={Spacing.XL}
      rowGap={Spacing.S}
      px={5}
      py={Spacing.L}
      bgcolor="grey.100"
      sx={{ breakAfter: "avoid", breakInside: "avoid" }}
    >
      <Typography variant="body1" fontWeight={700}>
        {title}
      </Typography>
      {details.length > 0 && (
        <Flex columnGap={Spacing.XL} flexWrap="wrap">
          {details.map((detail) => (
            <Typography key={detail.label} variant="body2" color="text.secondary" noWrap>
              {detail.label}{" "}
              <Box component="span" color="text.primary" fontWeight={500}>
                {detail.value}
              </Box>
            </Typography>
          ))}
        </Flex>
      )}
    </Flex>
    <Box p={5}>{children}</Box>
  </Box>
);
